export default "__VITE_ASSET__NyOrOxp$__"